import { TAuthState } from '@/redux/reducers/auth';
import { TAuthSignUpSuccess } from '@/redux/actions/auth';

export const authSignupUpdateState = (state: TAuthState, action: TAuthSignUpSuccess): TAuthState => ({
  ...state,
  authSignUpResponse: action.payload.response,
});
